import api from '@/services/api/index';

import {
  LOAD_EINGABEARTEN, LOAD_PRUEFAKTIONEN, LOAD_KATEGORIEN,
  LOAD_WARENEINGANGSPRUEFUNG_STATI,
} from './actions.type';
import {
  SET_EINGABEARTEN, SET_EINGABEARTEN_LOADED, SET_PRUEFAKTIONEN, SET_PRUEFAKTIONEN_LOADED,
  SET_WARENEINGANGSPRUEFUNG_STATI,
  SET_WARENEINGANGSPRUEFUNG_STATI_LOADED,
} from './mutations.type';

export default {
  namespaced: true,
  state: {
    eingabearten: [],
    _eingabearten_loaded: false,
    pruefaktionen: [],
    _pruefaktionen_loaded: false,
    wareneingangspruefung_stati: [],
    _wareneingangspruefung_stati_loaded: false,
  },
  mutations: {
    [SET_EINGABEARTEN](state, val) {
      state.eingabearten = val;
    },
    [SET_EINGABEARTEN_LOADED](state, val) {
      state.eingabearten_loaded = val;
    },
    [SET_PRUEFAKTIONEN](state, val) {
      state.pruefaktionen = val;
    },
    [SET_PRUEFAKTIONEN_LOADED](state, val) {
      state.pruefaktionen_loaded = val;
    },
    [SET_WARENEINGANGSPRUEFUNG_STATI](state, val) {
      state.wareneingangspruefung_stati = val;
    },
    [SET_WARENEINGANGSPRUEFUNG_STATI_LOADED](state, val) {
      state.wareneingangspruefung_stati_loaded = val;
    },
  },
  actions: {
    async [LOAD_EINGABEARTEN]({ commit, state }, force = false) {
      if (state.eingabearten_loaded && !force) {
        return state.eingabearten;
      }
      const response = await api.v1.wareneingangspruefung.eingabeart.get();
      commit(SET_EINGABEARTEN, response.data);
      commit(SET_EINGABEARTEN_LOADED, true);
      return response.data;
    },
    async [LOAD_PRUEFAKTIONEN]({ commit, state }, force = false) {
      if (state.pruefaktionen_loaded && !force) {
        return state.pruefaktionen;
      }
      const response = await api.v1.wareneingangspruefung.pruefaktion.get();
      commit(SET_PRUEFAKTIONEN, response.data);
      commit(SET_PRUEFAKTIONEN_LOADED, true);
      return response.data;
    },

    async [LOAD_WARENEINGANGSPRUEFUNG_STATI]({ commit, state }, force = false) {
      if (state.wareneingangspruefung_stati_loaded && !force) {
        return state.wareneingangspruefung_stati;
      }
      const response = await api.v1.wareneingangspruefung.status.get();
      commit(SET_WARENEINGANGSPRUEFUNG_STATI, response.data);
      commit(SET_WARENEINGANGSPRUEFUNG_STATI_LOADED, true);
      return response.data;
    },
    async [LOAD_KATEGORIEN]({ dispatch }) {
      return Promise.all([
        dispatch(LOAD_EINGABEARTEN),
        dispatch(LOAD_PRUEFAKTIONEN),
        dispatch(LOAD_WARENEINGANGSPRUEFUNG_STATI),
      ]);
    },
  },
  modules: {

  },
  getters: {
  },
};
